import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Products from './Products';
import Settings from './Settings';
import History from './History';

const AltTextGenerator = ({ initialTab }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(initialTab || 'products');

  useEffect(() => {
    if (initialTab != null && initialTab !== activeTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  const subTabLabels = {
    products: t('altTextGenerator.generateAltTextTab'),
    history: t('altTextGenerator.altTextHistory'),
    settings: t('altTextGenerator.settings'),
  };
  const pageTitle = `${t('altTextGenerator.title')} → ${subTabLabels[activeTab] ?? subTabLabels.products}`;

  return (
    <div className="container-fluid py-1">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0 fw-bold">{pageTitle}</h4>
      </div>

      {/* Info: What Generate Alt Text does - Only show for Products tab */}
      {activeTab === 'products' && (
        <div className="card border mb-3 border-start border-2 rounded-end" style={{ backgroundColor: '#f8f9fa', borderLeftColor: '#adb5bd' }}>
          <div className="card-body py-2 px-3">
            <ul className="mb-0 ps-3" style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>
              <li className="fw-semibold mb-1"><span className="text-dark">{t('altTextGenerator.infoCard1Label')}</span> {t('altTextGenerator.infoCard1Desc')}</li>
              <li className="fw-semibold mb-1"><span className="text-dark">{t('altTextGenerator.infoCard2Label')}</span> {t('altTextGenerator.infoCard2Desc')}</li>
              <li className="fw-semibold"><span className="text-dark">{t('altTextGenerator.infoCard3Label')}</span> {t('altTextGenerator.infoCard3Desc')}</li>
            </ul>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div>
        {activeTab === 'products' && <Products />}
        {activeTab === 'history' && <History />}
        {activeTab === 'settings' && <Settings />}
      </div>
    </div>
  );
};

export default AltTextGenerator;
